import React, {FC, useEffect, useRef, useState} from "react";
import {Modal} from "antd";
import closeIcon from "../../../../assets/icons/close.svg";
import './boardForm.scss';
import ToggleSwitch from "../../ToggleSwitch";
import UploadLogo from "../../UploadLogo";
import {Formik, Form,Field} from "formik";
import ButtonComponent from "../../ButtonComponent";
import InputField from "../../InputField";
import BoardService from "../../../../services/CourseServices/BoardService/board.service";
import {serialize} from "serializr";
import {BoardModel} from "../../../../models/CourseModels/BoardModel/board.model";
import {convertJSONToFormData} from "../../../utils/converJsonToFormData";
import {FILE_UPLOAD_BASE_URL} from "../../../../routes/routeConstants/apiRoutes";

interface BoardFormProps{
    title: string;
    visible: boolean;
    setVisible: Function;
    data?:any;
    refreshList?:Function;
    currentPageNumber?:number;
}

const BoardForm:FC<BoardFormProps> = (props) => {

    const {title, visible, setVisible, data, refreshList, currentPageNumber} = props;
    const formRef = useRef<any>();

    useEffect(()=>{
        setInitialValues({
            name: data?.name || null,
            acronym: data?.acronym || null,
            isActive: data?.isActive ? data.isActive : false,
            displayPicture: null,
        })
    },[data])

    const [buttonLoading,setButtonLoading] = useState<boolean>(false);
    const [initialValues,setInitialValues] = useState<any>(
        {
            name: null,
            acronym: null,
            isActive: true,
            displayPicture: null,
        }
    )

    const handleClose = () => {
        setVisible(false);
        formRef.current.resetForm(initialValues)
    }

    const handleSubmit = (values:any) => {
        setButtonLoading(true)
        let boardData = serialize(BoardModel,values);
        if(values?.displayPicture) boardData.display_picture = values.displayPicture;
        let jsonData = {board:boardData}
        let boardFormData = convertJSONToFormData(jsonData);
        if(!data) {
            BoardService.createBoard(boardFormData,
                () => {
                    if(refreshList) refreshList(currentPageNumber)
                    setVisible(false)
                    formRef.current.resetForm(initialValues)
                },
                () => {
                },
                () => {
                    setButtonLoading(false)
                },
            ).then()
        }else{
            BoardService.updateBoard(data?.id,boardFormData,
                () => {
                    if(refreshList) refreshList(currentPageNumber)
                    setVisible(false)
                    formRef.current.resetForm(initialValues)
                },
                () => {
                },
                () => {
                    setButtonLoading(false)
                },
            ).then()
        }
    }

    return(
        <Modal title={null}
               centered
               visible={visible}
               onCancel={handleClose}
               footer={null}
               className='board-form__modal'
               closeIcon={<img src={closeIcon} alt=''/>}
        >
            <Formik initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                    innerRef={formRef}
            >{({setFieldValue,values,resetForm})=> {
                return(
                    <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <div className='board-form__header'>
                            <div className='board-form__title'>{title}</div>
                            <div className='board-form__toggle'>
                                <Field name="isActive" as='switch'>
                                    <ToggleSwitch checked={values.isActive}
                                                  handleChange={() => {
                                                      setFieldValue('isActive', !values.isActive)
                                                  }}
                                    />
                                </Field>
                            </div>
                        </div>

                        <Field name="displayPicture" as='file-upload'>
                            <UploadLogo logoUrl={values?.displayPicture ?
                                                values?.displayPicture : data?.displayPictureUrl}
                                        setFile={setFieldValue}
                            />
                        </Field>

                        <div className="board-form__input">
                            <div className='board-form__label'>Name of board *</div>
                            <InputField type="text" name="name" placeholder="Type board name"/>
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Acronym *</div>
                            <InputField type="text" name="acronym" placeholder="Type acronym"/>
                        </div>

                        <div className='board-form__action'>
                            <div className='board-form__button' onClick={() => {
                                handleClose();
                                resetForm({})
                            }}>
                                <ButtonComponent buttonContent='Cancel'
                                                 type='text'
                                />
                            </div>
                            <div className='board-form__button'>
                                <ButtonComponent buttonContent={data ? 'Update' : 'Create'}
                                                 type='primary'
                                                 htmlType='submit'
                                                 loading={buttonLoading}
                                />
                            </div>
                        </div>
                    </Form>
                )
            }}
            </Formik>
        </Modal>
    )
}

export default BoardForm;
